
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AccountDetailsViewModel } from '../../../../common/model/account/accountDetailsViewModel';
import { ActionType } from '../../../actions/model';
import { MeterEntriesValidateSuccess } from '../../../../common/model/meterReadings/meterEntriesValidateSuccess';
import { MeterTricResponse } from 'common/model/meterReadings/tricModels';


export interface TricMetersState {
    tricMeters: Record<string, MeterTricResponse> | null;
    tricMetersLoading: boolean;
    tricMetersLoaded: boolean;
    tricMetersLoadingError: string | null;
    tricMetersEntriesSending: boolean;
    didClientHasTricAccount: boolean;
}

const initialState: TricMetersState = {
    tricMeters: null,
    tricMetersLoading: false,
    tricMetersLoaded: false,
    tricMetersLoadingError: null,
    tricMetersEntriesSending: false,
    didClientHasTricAccount: false
};

export const tricMetersAndEntriesSlice = createSlice({
    name: '@@vp/accounts/tricMeters',
    initialState,
    reducers: {
        setTricMetersLoading(state, action: PayloadAction<TricMetersState['tricMetersLoading']>): void {
            state.tricMetersLoading = action.payload;
        },
        resetTricMeters(state): void {
            state.tricMeters = initialState.tricMeters;
            state.tricMetersLoaded = initialState.tricMetersLoaded;
            state.tricMetersLoading = initialState.tricMetersLoading;
            state.tricMetersLoadingError = initialState.tricMetersLoadingError;
        },
        setTricMeters(state, action: PayloadAction<Record<string, MeterTricResponse>>): void {
            state.tricMeters = { ...state.tricMeters, ...action.payload };
            state.tricMetersLoaded = true;
            state.tricMetersLoading = false;
        },
        setTricMetersLoadingError(state, action: PayloadAction<TricMetersState['tricMetersLoadingError']>): void {
            state.tricMetersLoadingError = action.payload;
        },
        setTricMeterEntriesSending(state, action: PayloadAction<TricMetersState['tricMetersEntriesSending']>): void {
            state.tricMetersEntriesSending = action.payload;
        },
        updateMeterReadingsByMeterId(state, action: PayloadAction<{ accountId: string; id: number; value: string }>): void {
            state.tricMeters?.[action.payload.accountId]?.groups.forEach(service => {
                service.counter.forEach(meter => {
                    if (meter.id === action.payload.id) {
                        meter.readings.previous = meter.readings.current;
                        meter.readings.current = action.payload.value;
                    }
                });
            });
        },
        setDidClientHasTricAccount(state, action: PayloadAction<TricMetersState['didClientHasTricAccount']>): void {
            state.didClientHasTricAccount = action.payload;
        },
    },
    extraReducers: {
        [ActionType.LOGOUT]: (): TricMetersState => initialState,
    }
});

export const {
    setTricMeters, resetTricMeters, setTricMetersLoading, setTricMetersLoadingError, setTricMeterEntriesSending, setDidClientHasTricAccount,
    updateMeterReadingsByMeterId
} = tricMetersAndEntriesSlice.actions;
